import EchoLibrary from 'laravel-echo'

import is from '../web/plugins/helper/is'

/**
 * @return {EchoLibrary|null}
 */
export const connect = () => {
  const appUrl = is.getValueSetting('echoServerHost')
  const port = is.getValueSetting('echoServerPort')
  if (is.checkVariable(appUrl) && is.checkVariable(port)) {
    const token = localStorage.getItem('token') || ''

    return new EchoLibrary({
      broadcaster: 'socket.io',
      host: `${appUrl}:${port}`,
      // namespace: 'App',
      auth: {
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    })
  }

  return null
}
